





























import { Component, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import CompletedOfferData from '@/ts/CompletedOfferData';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import { dateFormat } from '@/ts/DefaultTableConfigs';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class CompletedOffers extends Mixins(NotifyMethods) {
    public tableEntity: string = 'CompletedOffers';

    constructor() {
        super();
    }

    get columns(): any {
       return [
           { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
           { name: 'name', label: this.$t('general.name', 'Name'), align: 'left', field: 'name', sortable: true, required: false },
           { name: 'sentDate', label: this.$t('general.sent-date', 'Sent date'), align: 'left', field: 'sentDate', sortable: true, required: false, filterType: 'date', dateFormat },
           { name: 'moveInDate', label: this.$t('general.move-in-date', 'Move-in date'), align: 'left', field: 'moveInDate', sortable: true, required: false, filterType: 'date', dateFormat },
           { name: 'project', label: this.$t('general.project', 'Project'), align: 'left', field: 'project', sortable: true, required: false },
           { name: 'groups', label: this.$t('general.groupings', 'Groups'), align: 'left', field: 'groups', sortable: true, required: false, filterType: 'array' },
           { name: 'unitId', label: this.$t('general.unit-id', 'Unit ID'), align: 'left', field: 'unitId', sortable: true, required: false },
           { name: 'type', label: this.$t('general.type', 'Type'), align: 'left', field: 'type', sortable: true, required: false },
           { name: 'address', label: this.$t('general.address', 'Address'), align: 'left', field: 'address', sortable: true, required: false },
           { name: 'email', label: this.$t('general.email', 'Email'), align: 'left', field: 'email', sortable: true, required: false },
           { name: 'phone', label: this.$t('general.phone', 'Phone'), align: 'left', field: 'phone', sortable: true, required: false },
           { name: 'createdBy', label: this.$t('general.created-by', 'Created by'), align: 'left', field: 'createdBy', sortable: true, required: false },
           { name: 'completedDate', label: this.$t('general.completed-date', 'Completed date'), align: 'left', field: 'completedDate', sortable: true, required: false, filterType: 'date', dateFormat },
           { name: 'completedBy', label: this.$t('general.completed-by', 'Completed by'), align: 'left', field: 'completedBy', sortable: true, required: false },
           { name: 'closedAt', label: this.$t('general.closed-at', 'Closed at'), align: 'left', field: 'closedAt', sortable: true, required: false, filterType: 'date', dateFormat },
       ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'name',
                'moveInDate',
                'project',
                'groups',
                'address',
                'type',
            ],
        };
    }

    get completedOffers(): CompletedOfferData[] {
        return this.$store.getters['PresentationFlows/getCompletedOffers'];
    }

    public closedOffer(closedDate: any)  {
        return this.notify('offer_has_been_closed_at', 'info', closedDate);
    }

    public archivedOffer(archivedDate: any)  {
        return this.notify('offer_has_been_archived_at', 'info', archivedDate);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_COMPLETED_OFFERS, { project: this.$store.getters['PresentationFlows/getCurrentProject'] });
    }
}
